import styled from "styled-components";

export const DateInputWrapper = styled.div`
  grid-area: ${({ gridArea }) => gridArea};
  margin: ${({ margin }) => margin}px;

  position: relative;
`;
